<template>
  <v-container fluid>
    <v-card>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left> mdi-filter-variant </v-icon>
              Filtros
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form :disabled="buscando" @submit.prevent="aplicarFiltros">
              <v-row>
                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.descricaoItemCliente"
                    label="Descrição Item Cliente"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.descricaoItemVo"
                    label="Descrição item VO"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.ncmItemCliente"
                    label="NCM Item Cliente"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.ncmItemVo"
                    label="NCM Item VO"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.codigoItemCliente"
                    label="Código do Item Cliente"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.codigoBarra"
                    label="Código de Barra"
                    :loading="buscando"
                    type="number"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field v-model="filtro.cfop" label="CFOP" :loading="buscando" />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field v-model="filtro.uf" label="UF Destino" :loading="buscando" />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.nrChaveNF"
                    label="NF / Chave NF-e"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.cnpjCodigoFornecedor"
                    label="CNPJ / Código do Fornecedor"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.cnpjFilial"
                    label="CNPJ da Filial"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-autocomplete
                    v-model="filtro.statusConferencia"
                    :items="['NAO_CONFERIDO', 'EM_DUVIDA', 'CONFERIDO']"
                    label="Conferência"
                    :loading="buscando"
                    clearable
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-autocomplete
                    v-model="filtro.motivoDuvida"
                    :items="itensMotivoDuvida"
                    label="Motivo Dúvida"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-autocomplete
                    v-model="filtro.outros"
                    :items="itensOutrosFiltros"
                    label="Outros filtros"
                    :loading="buscando"
                    clearable
                    multiple
                    small-chips
                    single-line
                    deletable-chips
                    solo
                    :search-input.sync="search"
                    @change="search = ''"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.codigoCstIcmsCliente"
                    label="CST ICMS Cliente"
                    :loading="buscando"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.percentualIcmsCliente"
                    label="% ICMS Cliente"
                    :loading="buscando"
                    hint="Use '>' ou '<' para valores maiores/menores. (Ex: >10)"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.codigoCstPisCliente"
                    label="CST PIS Cliente"
                    :loading="buscando"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.percentualPisCliente"
                    label="% PIS Cliente"
                    :loading="buscando"
                    hint="Use '>' ou '<' para valores maiores/menores. (Ex: >10)"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.codigoCstIcmsVo"
                    label="CST ICMS VO"
                    :loading="buscando"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.percentualIcmsVo"
                    label="% ICMS VO"
                    :loading="buscando"
                    hint="Use '>' ou '<' para valores maiores/menores. (Ex: >10)"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.codigoCstPisVo"
                    label="CST PIS VO"
                    :loading="buscando"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field
                    v-model="filtro.percentualPisVo"
                    label="% PIS VO"
                    :loading="buscando"
                    hint="Use '>' ou '<' para valores maiores/menores. (Ex: >10)"
                  />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field v-model="filtro.divIcms" label="R$ Div ICMS" :loading="buscando" />
                </v-col>

                <v-col sm="4" md="2">
                  <v-text-field v-model="filtro.divPC" label="R$ Div PC" :loading="buscando" />
                </v-col>
              </v-row>

              <v-row justify="end">
                <v-col cols="auto" class="d-flex align-center">
                  <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                    <v-icon left> mdi-magnify </v-icon>
                    Aplicar
                  </v-btn>
                  <v-btn
                    class="ml-4"
                    color="normal"
                    outlined
                    type="submit"
                    :loading="buscando"
                    @click.stop.prevent="limparSelecaoDeFiltros"
                  >
                    <v-icon left> mdi-autorenew </v-icon>
                    Limpar
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    class="ml-4"
                    color="green"
                    outlined
                    type="submit"
                    :loading="salvando"
                    @click.stop.prevent="marcarVerdesPelaEntrada"
                  >
                    <v-icon left> mdi-checkbox-multiple-marked-outline </v-icon>
                    Marcar verdes pela Entrada
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-card :disabled="!permiteAtualizarStatus" class="mt-2 px-5">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <v-autocomplete
              v-model="status.conferencia"
              :items="['NAO_CONFERIDO', 'EM_DUVIDA', 'CONFERIDO']"
              label="Conferência"
            />
          </v-col>
          <v-col class="text-center">
            <v-autocomplete
              v-model="status.motivoDuvida"
              :items="itensMotivoDuvida"
              :disabled="!permiteInformarMotivoDuvida"
              label="Motivo Dúvida"
            />
          </v-col>
          <v-col class="text-center">
            <v-text-field v-model="status.observacao" label="Observação" />
          </v-col>
          <v-col class="text-center align-center">
            <v-btn
              width="325"
              color="primary"
              :loading="salvando"
              @click="atualizarStatusConferencia"
            >
              Atualizar Status de Conferência
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="mt-2">
      <v-container fluid>
        <v-data-table
          v-model="itensSelecionados"
          :headers="headers"
          :loading="buscando"
          :items="saidas"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': [10, 20, 50, 100, 200, 300, 1000, 3000, 5000, 10000]
          }"
          show-select
          :options.sync="options"
          :server-items-length="totalDeElementos"
        >
          <template #[`item.statusConferencia`]="{ item }">
            <div
              v-if="item.statusConferenciaItensVinculados.statusConferencia === 'CONFERIDO'"
              class="green fill-height pa-0 ma-0"
              style="width: 100%"
            />
            <div
              v-else-if="item.statusConferenciaItensVinculados.statusConferencia === 'EM_DUVIDA'"
              class="orange fill-height pa-0 ma-0"
              style="width: 100%"
            />
            <div v-else class="fill-height pa-0 ma-0" style="width: 100%" />
          </template>

          <template #[`item.itens`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span
                @click="abrirEmNovaJanela('TelaDeItensVO', { descricao: item.itemVo.descricao })"
              >
                <a class="orange--text text--darken-3"> {{ item.itemVo.descricao }} </a>
              </span>
              <span> Cód. Prod.: {{ item.itemVo.codigo }} </span>
              <span> Cód. Barra: {{ item.itemVo.codigoBarra }} </span>

              <v-divider class="my-1" />

              <span
                @click="
                  abrirEmNovaJanela('TelaDeItensCliente', {
                    descricao: item.itemClienteSaidaAtualizacao.itemCliente.descricaoItem
                  })
                "
              >
                <a class="orange--text text--darken-3">
                  {{ item.itemClienteSaidaAtualizacao.itemCliente.descricaoItem }}
                </a>
              </span>
              <span>
                Cód. Prod.: {{ item.itemClienteSaidaAtualizacao.itemCliente.codigoItem }}
              </span>
              <span>
                Cód. Barra: {{ item.itemClienteSaidaAtualizacao.itemCliente.codigoBarra }}
              </span>

              <v-divider class="my-1" />

              <span
                v-if="item.notaFiscalItem"
                @click="
                  abrirEmNovaJanela('TelaDeNFes', { descricao: item.notaFiscalItem.descricao })
                "
              >
                {{ item.notaFiscalItem.descricao }}
              </span>
              <span v-if="item.notaFiscalItem">
                Cód. Barra: {{ item.notaFiscalItem.codigoBarra }}
              </span>
            </div>
          </template>

          <template #[`item.ufs`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> {{ item.itemVo.icmsSaida.uf.sigla }} </span>

              <v-divider class="my-1" />

              <span> </span>

              <v-divider class="my-1" />

              <span>
                {{ item.notaFiscalItem ? item.notaFiscalItem.notaFiscal.uf.sigla : '' }}
              </span>
            </div>
          </template>

          <template #[`item.cfops`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> </span>

              <v-divider class="my-1" />

              <span>
                {{
                  item.itemClienteSaidaAtualizacao.cfop
                    ? item.itemClienteSaidaAtualizacao.cfop.codigo
                    : ''
                }}
              </span>

              <v-divider class="my-1" />

              <span> {{ item.notaFiscalItem ? item.notaFiscalItem.cfop.codigo : '' }} </span>
            </div>
          </template>

          <template #[`item.data`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> </span>

              <v-divider class="my-1" />

              <span>
                {{ formatDate(item.itemClienteSaidaAtualizacao.dataEmissao) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{
                  item.notaFiscalItem
                    ? formatDate(item.notaFiscalItem.notaFiscal.dataHoraEmissao)
                    : ''
                }}
              </span>
            </div>
          </template>

          <template #[`item.ncms`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span
                @click="
                  abrirDialogNcm(
                    item.itemVo.ncm.id,
                    item.itemClienteSaidaAtualizacao.itemCliente.ncm.id
                  )
                "
              >
                <a class="orange--text text--darken-3"> {{ item.itemVo.ncm.codigo }} </a>
              </span>

              <v-divider class="my-1" />

              <span
                @click="
                  abrirDialogNcm(
                    item.itemVo.ncm.id,
                    item.itemClienteSaidaAtualizacao.itemCliente.ncm.id
                  )
                "
              >
                <a class="orange--text text--darken-3">
                  {{ item.itemClienteSaidaAtualizacao.itemCliente.ncm.codigo }}
                </a>
              </span>

              <v-divider class="my-1" />

              <span
                @click="
                  abrirDialogNcm(
                    item.itemVo.ncm.id,
                    item.itemClienteSaidaAtualizacao.itemCliente.ncm.id
                  )
                "
              >
                <a class="orange--text text--darken-3">
                  {{ item.notaFiscalItem ? item.notaFiscalItem.ncm.codigo : '' }}
                </a>
              </span>
            </div>
          </template>

          <template #[`item.valorItem`]="{ item }">
            <span>
              {{
                item.itemClienteSaidaAtualizacao.valorItem.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                })
              }}
            </span>
          </template>

          <template #[`item.cstIcms`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> {{ String(item.itemVo.icmsSaida.cst.codigo).padStart(2, '0') }}</span>

              <v-divider class="my-1" />

              <span>
                {{ String(item.itemClienteSaidaAtualizacao.codigoCstIcms).padStart(3, '0') }}</span
              >

              <v-divider class="my-1" />

              <span>
                {{
                  item.notaFiscalItem
                    ? String(item.notaFiscalItem.cstIcms.codigo).padStart(2, '0')
                    : ''
                }}
              </span>
            </div>
          </template>

          <template #[`item.porcentagemIcms`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span>
                {{ formatNumber(item.itemVo.icmsSaida.icmsSaida) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{ formatNumber(item.itemClienteSaidaAtualizacao.percentualIcms) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{ item.notaFiscalItem ? formatNumber(item.notaFiscalItem.porcentagemIcms) : '' }}
              </span>
            </div>
          </template>

          <template #[`item.divIcms`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span>
                BC:
                {{
                  item.itemClienteSaidaAtualizacao.percentualIcms > 0
                    ? formatNumber(item.itemClienteSaidaAtualizacao.valorBaseCalculoIcms)
                    : '0,00'
                }}
              </span>
              <span> Vlr: {{ formatNumber(item.itemClienteSaidaAtualizacao.valorIcms) }} </span>
              <span>
                ≠:
                {{ formatNumber(item.diferencaCreditoItemClienteVo) }}
              </span>

              <span v-if="item.notaFiscalItem">
                R$ XML: {{ formatNumber(item.notaFiscalItem.notaFiscal.valor) }}
              </span>
            </div>
          </template>

          <template #[`item.cstPis`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> {{ String(item.itemVo.pisCofins.cstSaida.codigo).padStart(2, '0') }}</span>

              <v-divider class="my-1" />

              <span>
                {{ String(item.itemClienteSaidaAtualizacao.codigoCstPis).padStart(2, '0') }}</span
              >

              <v-divider class="my-1" />

              <span>
                {{
                  item.notaFiscalItem
                    ? String(item.notaFiscalItem.cstPis.codigo).padStart(2, '0')
                    : ''
                }}
              </span>
            </div>
          </template>

          <template #[`item.porcentagemPis`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> {{ formatNumber(item.itemVo.pisCofins.percentualPISSaida) }} </span>

              <v-divider class="my-1" />

              <span>
                {{ formatNumber(item.itemClienteSaidaAtualizacao.percentualPis) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{ item.notaFiscalItem ? formatNumber(item.notaFiscalItem.porcentagemPis) : '' }}
              </span>
            </div>
          </template>

          <template #[`item.divPis`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span>
                BC:
                {{ formatNumber(item.itemClienteSaidaAtualizacao.valorBaseCalculoPis) }}
              </span>
              <span>
                Vlr:
                {{
                  item.itemClienteSaidaAtualizacao.percentualPis > 0
                    ? formatNumber(item.itemClienteSaidaAtualizacao.valorPis)
                    : '0,00'
                }}
              </span>
              <span> ≠: {{ formatNumber(item.diferencaPisItemClienteVo) }} </span>

              <span v-if="item.notaFiscalItem">
                R$ XML: {{ formatNumber(item.notaFiscalItem.notaFiscal.valor) }}
              </span>
            </div>
          </template>

          <template #[`item.cstCofins`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span> {{ String(item.itemVo.pisCofins.cstSaida.codigo).padStart(2, '0') }} </span>

              <v-divider class="my-1" />

              <span>
                {{ String(item.itemClienteSaidaAtualizacao.codigoCstCofins).padStart(2, '0') }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{
                  item.notaFiscalItem
                    ? String(item.notaFiscalItem.cstCofins.codigo).padStart(2, '0')
                    : ''
                }}
              </span>
            </div>
          </template>

          <template #[`item.porcentagemCofins`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span>
                {{ formatNumber(item.itemVo.pisCofins.percentualCOFINSSaida) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{ formatNumber(item.itemClienteSaidaAtualizacao.percentualCofins) }}
              </span>

              <v-divider class="my-1" />

              <span>
                {{ item.notaFiscalItem ? formatNumber(item.notaFiscalItem.porcentagemPis) : '' }}
              </span>
            </div>
          </template>

          <template #[`item.divCofins`]="{ item }">
            <div class="d-flex flex-column justify-center">
              <span>
                BC:
                {{ formatNumber(item.itemClienteSaidaAtualizacao.valorBaseCalculoCofins) }}
              </span>
              <span>
                Vlr:
                {{
                  item.itemClienteSaidaAtualizacao.percentualCofins > 0
                    ? formatNumber(item.itemClienteSaidaAtualizacao.valorCofins)
                    : '0,00'
                }}
              </span>
              <span>
                ≠:
                {{ formatNumber(item.diferencaCofinsItemClienteVo) }}
              </span>

              <span v-if="item.notaFiscalItem">
                R$ XML: {{ formatNumber(item.notaFiscalItem.notaFiscal.valor) }}
              </span>
            </div>
          </template>

          <template #[`item.info`]="{ item }">
            <div class="d-flex flex-column justify-center py-1">
              <v-tooltip left>
                <template #activator="{ on }">
                  <v-icon dense v-on="on" @click="abrirDialogInfo(item)">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>Mais informações</span>
              </v-tooltip>

              <v-tooltip left>
                <template #activator="{ on }">
                  <v-icon dense class="my-2" v-on="on" @click="abrirGoogle(item)">
                    mdi-google
                  </v-icon>
                </template>
                <span>Google</span>
              </v-tooltip>

              <v-tooltip left>
                <template #activator="{ on }">
                  <v-icon dense v-on="on" @click="abrirEmNovaJanela('TelaDeNFes')">
                    mdi-file-document-outline
                  </v-icon>
                </template>
                <span>XML</span>
              </v-tooltip>

              <v-tooltip left>
                <template #activator="{ on }">
                  <v-icon
                    class="mt-2"
                    dense
                    v-on="on"
                    @click="
                      abrirEmNovaJanela('TelaDeEntradas', {
                        codigoItemCliente: item.itemClienteSaidaAtualizacao.itemCliente.codigoItem,
                        atualizacao: JSON.stringify(atualizacao)
                      })
                    "
                  >
                    mdi-arrow-left
                  </v-icon>
                </template>
                <span>Entrada</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="showDialogInfo" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Informações adicionais</v-card-title>
        <v-card-text>
          <v-list color="py-0 mt-5">
            <v-list-item>
              <span>
                <strong> Observação: </strong>
                {{ itemInfo.observacao ? itemInfo.observacao : 'Sem observação informada' }}
              </span>
            </v-list-item>
            <v-list-item>
              <span>
                <strong> Motivo Dúvida: </strong>
                {{
                  itemInfo.motivoDuvida ? itemInfo.motivoDuvida : 'Sem motivo de dúvida informado'
                }}
              </span>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="red darken-1" @click="showDialogInfo = false"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogNcm" persistent max-width="900">
      <v-card>
        <v-card-title class="headline">Classificações dos NCM</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-toolbar flat color="white">
                <v-toolbar-title>NCM Item VO</v-toolbar-title>
              </v-toolbar>
              <v-simple-table>
                <template #default>
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <v-simple-table>
                          <template #default>
                            <tbody>
                              <tr v-for="item in classificacoesNcmItemVo" :key="item.descricao">
                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12)">
                                  {{ item.codigo }}
                                </td>
                                <td>
                                  <span>
                                    {{ item.descricao }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col>
              <v-toolbar flat color="white">
                <v-toolbar-title>NCM Item Cliente</v-toolbar-title>
              </v-toolbar>
              <v-simple-table>
                <template #default>
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <v-simple-table>
                          <template #default>
                            <tbody>
                              <tr
                                v-for="item in classificacoesNcmItemCliente"
                                :key="item.descricao"
                              >
                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12)">
                                  {{ item.codigo }}
                                </td>
                                <td>
                                  <span>
                                    {{ item.descricao }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="red darken-1" @click="showDialogNcm = false"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ItemClienteVoNfService from '@/services/atualizacao/itemClienteVoNf'
import AtualizacaoService from '@/services/atualizacao/atualizacao'
import NCMService from '@/services/ncm/ncm'
import Atualizacao from '@/models/atualizacao'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { formatDate, formatNumber } from '@/shareds/formatacoes'

export default {
  components: { SnackbarMessage },

  data: () => ({
    saidas: [],
    atualizacao: new Atualizacao(),
    itemInfo: {},
    headers: [
      { text: '', value: 'statusConferencia', width: '1%' },
      { text: 'Item', value: 'itens', divider: true },
      { text: 'UF', value: 'ufs', divider: true, sortable: false },
      { text: 'CFOP', value: 'cfops', divider: true },
      { text: 'Data', value: 'data', divider: true },
      { text: 'NCM', value: 'ncms', divider: true },
      { text: 'Vlr Item R$', value: 'valorItem', divider: true },
      { text: 'CST ICMS', value: 'cstIcms', divider: true },
      { text: '% ICMS', value: 'porcentagemIcms', divider: true },
      { text: 'Div ICMS', value: 'divIcms', divider: true, sortable: false },
      { text: 'CST PIS', value: 'cstPis', divider: true },
      { text: '% PIS', value: 'porcentagemPis', divider: true },
      { text: 'Div PIS', value: 'divPis', divider: true, sortable: false },
      { text: 'CST COF', value: 'cstCofins', divider: true },
      { text: '% COF', value: 'porcentagemCofins', divider: true },
      { text: 'Div COFINS', value: 'divCofins', divider: true, sortable: false },
      { text: '', value: 'info', sortable: false }
    ],
    filtro: { outros: [] },
    filtros: {},
    itensMotivoDuvida: [
      'FALTOU_TEMPO',
      'FALTOU_XML',
      'FORNECEDOR_ERROU',
      'ITEM_POLEMICO',
      'VINCULO_ERRADO',
      'CFOP_NAO_AUDITADO',
      'IMPORTADOR',
      'PRODUTO_IMPORTADO',
      'OUTRO',
      'IPI',
      'DESCONTO',
      'CREDITO_IGUAL',
      'ARREDONDAMENTO'
    ],
    itensOutrosFiltros: [
      'ICMS 100% Conferido',
      'Pis Cofins 100% Conferido',
      'Fornecedor 100% Conferido',
      'Somente CFOPs Auditaveis',
      'Somente Azul ICMS',
      'Somente Vermelho ICMS',
      'Somente com Divergência de NCM',
      'Somente com NCM Igual',
      'Somente Pesáveis (sem Código de Barra)',
      'Somente Sem Regra ICMS',
      'Somente Sem Regra PIS/COFINS',
      'Somente com Divergência de VALOR EM R$ de ICMS',
      'Somente com Divergência de ALIQUOTA % de ICMS',
      'Somente com Divergência de VALOR EM R$ de PIS',
      'Somente com Divergência de ALIQUOTA % de PIS',
      'Somente com Divergência de VALOR EM R$ de COFINS',
      'Somente com Divergência de ALIQUOTA % de COFINS',
      'Somente com Divergência de CST de ICMS',
      'Somente com Divergência de CST de PIS',
      'Somente com Divergência de CST de COFINS'
    ],
    status: {},
    itensSelecionados: [],
    classificacoesNcmItemVo: [],
    classificacoesNcmItemCliente: [],
    buscando: false,
    salvando: false,
    showDialogInfo: false,
    showDialogNcm: false,
    itensParam: {},
    snackbar: new SnackBar(),
    formatDate: formatDate,
    formatNumber: formatNumber,

    totalDeElementos: 0,
    options: {
      page: 1,
      itensPerPage: 0,
      sortBy: []
    },
    search: ''
  }),

  computed: {
    permiteAtualizarStatus() {
      return this.itensSelecionados.length > 0
    },
    permiteInformarMotivoDuvida() {
      return this.status.conferencia === 'EM_DUVIDA'
    }
  },

  watch: {
    options: {
      handler() {
        this.buscarSaidas()
      },
      deep: true
    }
  },

  created() {
    if (this.$route.params.atualizacao) this.atualizacao = this.$route.params.atualizacao
    else this.atualizacao = JSON.parse(this.$route.query.atualizacao)

    if (this.$route.query.codigoItemCliente) {
      this.filtro.codigoItemCliente = this.$route.query.codigoItemCliente
      this.aplicarFiltros()
    }
  },

  methods: {
    abrirEmNovaJanela(routeName, parameter) {
      let routeData = this.$router.resolve({
        name: routeName,
        query: parameter
      })
      window.open(routeData.href, '_blank')
    },

    abrirGoogle(item) {
      window.open(
        `https://www.google.com.br/search?q=${item.itemClienteSaidaAtualizacao.itemCliente.codigoBarra}`,
        '_blank'
      )
    },

    async abrirDialogNcm(idNcmItemVo, idNcmItemCliente) {
      const [ncmsItemVo, ncmsItemCliente] = await Promise.all([
        NCMService.getClassificacoesByNCM(idNcmItemVo),
        NCMService.getClassificacoesByNCM(idNcmItemCliente)
      ])

      this.classificacoesNcmItemVo = ncmsItemVo
      this.classificacoesNcmItemCliente = ncmsItemCliente

      this.showDialogNcm = true
    },

    abrirDialogInfo(item) {
      this.itemInfo = item.statusConferenciaItensVinculados
      this.showDialogInfo = true
    },

    limparSelecaoDeFiltros() {
      this.filtro = {
        outros: []
      }
    },

    aplicarFiltros() {
      Object.assign(this.options, {
        page: 1
      })

      this.filtros = {
        descricaoItemCliente: this.filtro.descricaoItemCliente || undefined,
        descricaoItemVo: this.filtro.descricaoItemVo || undefined,
        ncmItemCliente: this.filtro.ncmItemCliente || undefined,
        ncmItemVo: this.filtro.ncmItemVo || undefined,
        codigoItemCliente: this.filtro.codigoItemCliente || undefined,
        codigoBarra: this.filtro.codigoBarra || undefined,
        cfop: this.filtro.cfop || undefined,
        uf: this.filtro.uf || undefined,
        nrChaveNF: this.filtro.nrChaveNF || undefined,
        cnpjCodigoFornecedor: this.filtro.cnpjCodigoFornecedor || undefined,
        cnpjFilial: this.filtro.cnpjFilial || undefined,
        statusConferencia: this.filtro.statusConferencia || undefined,
        motivoDuvida: this.filtro.motivoDuvida || undefined,
        somenteConferidoIcms: this.filtro.outros.includes('ICMS 100% Conferido') || undefined,
        somenteConferidoPisCofins:
          this.filtro.outros.includes('Pis Cofins 100% Conferido') || undefined,
        somenteConferidoFornecedor:
          this.filtro.outros.includes('Fornecedor 100% Conferido') || undefined,
        somenteCfopAuditavel: this.filtro.outros.includes('Somente CFOPs Auditaveis') || undefined,
        somenteAzulIcms: this.filtro.outros.includes('Somente Azul ICMS') || undefined,
        somenteVermelhoIcms: this.filtro.outros.includes('Somente Vermelho ICMS') || undefined,
        somenteNcmDivergentes:
          this.filtro.outros.includes('Somente com Divergência de NCM') || undefined,
        somenteNcmIguais: this.filtro.outros.includes('Somente com NCM Igual') || undefined,
        somenteSemCodBarra:
          this.filtro.outros.includes('Somente Pesáveis (sem Código de Barra)') || undefined,
        somenteSemRegraIcms: this.filtro.outros.includes('Somente Sem Regra ICMS') || undefined,
        somenteSemRegraPisCofins:
          this.filtro.outros.includes('Somente Sem Regra PIS/COFINS') || undefined,
        somenteBcIcmsDivergente:
          this.filtro.outros.includes('Somente com Divergência de VALOR EM R$ de ICMS') ||
          undefined,
        somenteBcPisDivergente:
          this.filtro.outros.includes('Somente com Divergência de VALOR EM R$ de PIS') || undefined,
        somenteBcCofinsDivergente:
          this.filtro.outros.includes('Somente com Divergência de VALOR EM R$ de COFINS') ||
          undefined,
        somenteAliquotaIcmsIguais:
          this.filtro.outros.includes('Somente com ALIQUOTA FINAL % de ICMS IGUAL') || undefined,
        somenteAliquotaIcmsDivergentes:
          this.filtro.outros.includes('Somente com Divergência de ALIQUOTA % de ICMS') || undefined,
        somenteAliquotaPisDivergentes:
          this.filtro.outros.includes('Somente com Divergência de ALIQUOTA % de PIS') || undefined,
        somenteAliquotaCofinsDivergentes:
          this.filtro.outros.includes('Somente com Divergência de ALIQUOTA % de COFINS') ||
          undefined,
        somenteCstIcmsDivergentes:
          this.filtro.outros.includes('Somente com Divergência de CST de ICMS') || undefined,
        somenteCstPisDivergentes:
          this.filtro.outros.includes('Somente com Divergência de CST de PIS') || undefined,
        somenteCstCofinsDivergentes:
          this.filtro.outros.includes('Somente com Divergência de CST de COFINS') || undefined,
        codigoCstIcmsCliente: this.filtro.codigoCstIcmsCliente || undefined,
        percentualIcmsCliente: this.filtro.percentualIcmsCliente || undefined,
        codigoCstPisCliente: this.filtro.codigoCstPisCliente || undefined,
        percentualPisCliente: this.filtro.percentualPisCliente || undefined,
        codigoCstIcmsVo: this.filtro.codigoCstIcmsVo || undefined,
        percentualIcmsVo: this.filtro.percentualIcmsVo || undefined,
        codigoCstPisVo: this.filtro.codigoCstPisVo || undefined,
        percentualPisVo: this.filtro.percentualPisVo || undefined,
        valorDivIcms: this.filtro.divIcms || undefined,
        valorDivPC: this.filtro.divPC || undefined
      }

      this.buscarSaidas()
    },

    async marcarVerdesPelaEntrada() {
      this.salvando = true
      try {
        await AtualizacaoService.marcarVerdesPelaEntrada(this.atualizacao.id)
        this.snackbar.snackTextParam =
          'Proceso finalizado com sucesso, para verificar os itens marcados pesquise novamente.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro durante o processo.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.salvando = false
      }
    },

    async buscarSaidas() {
      this.itensSelecionados = []
      this.buscando = true
      this.saidas = []
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      if (!this.filtro.outros) this.filtro.outros = []

      const pagination = {
        page: this.options.page - 1,
        size: this.options.itemsPerPage,
        sort: this.options.sortBy.map(
          (sort, indice) => `${sort},${this.options.sortDesc[indice] ? 'DESC' : 'ASC'}`
        )[0]
      }

      try {
        const response = await ItemClienteVoNfService.getAllByAtualizacao(
          this.atualizacao.id,
          'saidas',
          {
            ...this.filtros,
            ...pagination
          }
        )
        this.saidas = response.content
        this.totalDeElementos = response.totalElements
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.buscando = false
      }
    },

    async atualizarStatusConferencia() {
      if (
        this.status.conferencia === 'EM_DUVIDA' &&
        !this.status.motivoDuvida &&
        !this.status.observacao
      ) {
        this.snackbar.snackTextParam = 'Necessário informar o motivo ou uma observação da dúvida.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
        return
      }

      this.salvando = true

      var indices = this.itensSelecionados.map((item) => this.saidas.indexOf(item))

      const data = {
        itensVinculadosId: this.itensSelecionados.map((item) => item.id),
        statusConferencia: this.status.conferencia,
        motivoDuvida: this.status.motivoDuvida,
        observacao: this.status.observacao
      }

      try {
        await ItemClienteVoNfService.updateStatusConferencia(data)
        this.snackbar.snackTextParam = 'Conferência atualizada com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        indices.forEach((indice) => {
          this.saidas[
            indice
          ].statusConferenciaItensVinculados.statusConferencia = this.status.conferencia
          this.saidas[indice].statusConferenciaItensVinculados.observacao = this.status.observacao
          this.saidas[
            indice
          ].statusConferenciaItensVinculados.motivoDuvida = this.status.motivoDuvida
        })

        this.itensSelecionados = []
        this.status = {}
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 0.75rem;
  padding: 5px 16px;
}
</style>
